<template>
  <div class="liveList">
    <div
      class="common"
      v-if="list1.length"
    >
      <h5>直播中</h5>
      <ul>
        <li
          v-for="(item,index) in list1"
          :key="index"
        >
          <div class="info">
            <div class="top">
              <p class="name">{{item.name}}</p>
              <p class="title">{{item.memo}}</p>
              <p
                class="time"
                v-if="item.livestatus<1002"
              >
                {{util.changeTime({time:item.starttime,line:'text',showMin:true,showWeek:true,hideYear:true})}} {{
                    util.showCount(item.livestatus==1000?item.reservecount:watchNumber)+'人'+(item.livestatus == 1001 ? " 在线": item.livestatus == 1000? "预约": " 观看")
                  }}
              </p>
            </div>
            <div class="line">
              <span class="left"></span>
              <span class="right"></span>
            </div>
            <div class="content">
              <p class="liveTime">{{item.livestatus == 1000? "距离开播还有":''}}</p>
              <div class="statusBox">
                <div
                  class="countdown"
                  v-if="item.livestatus == 1000"
                  v-html="showTime(item)"
                >
                </div>
                <div v-else-if="item.livestatus != 1000">
                  {{item.livestatus == 1001? "直播中": item.livestatus == 1003? "已结束，可回放": "已结束"}}
                </div>
                <i
                  class="liveLabel"
                  v-if="item.livestatus == 1001"
                ></i>
              </div>
              <div class="opation">
                <p
                  class="tip"
                  v-if="item.livestatus == 1001"
                  @click="detail(item,index,'list2')"
                >
                  <span>APP内打开</span>
                </p>

              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div
      class="common"
      v-if="list2.length"
    >
      <h5>待开播</h5>
      <ul>
        <li
          v-for="(item,index) in list2"
          :key="index"
        >
          <div class="info">
            <div class="top">
              <p class="name">{{item.name}}</p>
              <p class="title">{{item.memo}}</p>
              <p
                class="time"
                v-if="item.livestatus<1002"
              >
                {{util.changeTime({time:item.starttime,line:'text',showMin:true,showWeek:true,hideYear:true})}} · {{
                    util.showCount(item.livestatus==1000?item.reservecount:watchNumber)+'人'+(item.livestatus == 1001 ? " 在线": item.livestatus == 1000? "预约": " 观看")
                  }}
              </p>
            </div>
            <div class="line">
              <span class="left"></span>
              <span class="right"></span>
            </div>
            <div class="content">
              <p class="liveTime" v-if="item.livestatus == 1000&&!timeFlag">距离开播还有</p>
              <div class="statusBox">
                <div
                  class="countdown"
                  v-if="item.livestatus == 1000"
                  v-html="showTime(item)"
                >
                </div>
                <div v-else-if="item.livestatus != 1000">
                  {{item.livestatus == 1001? "直播中": item.livestatus == 1003? "已结束，可回放": "已结束"}}
                </div>
                <i
                  class="liveLabel"
                  v-if="item.livestatus == 1001"
                ></i>
              </div>
              <div class="opation">
                <p
                  :class="['tip',item.appoint?'default':'']"
                  v-if="item.livestatus == 1000"
                  @click="subscribe(item,index,'list2')"
                >
                  <span>{{item.appoint?'已预约':'开播提醒'}}</span>
                </p>
                <p
                  class="tip"
                  v-if="item.livestatus == 1001"
                  @click="detail(item,index,'list2')"
                >
                  <span>APP内查看</span>
                </p>

              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: '直播预告',
    };
  },
  data() {
    return {
      id: '',
      list1: [],
      list2: [],
      systemtime: '',
      time: '',
      timeFlag: 0,//当超时未开播时  等待10在调用接口
    }
  },
  beforeDestroy() {
    clearInterval(this.time)
  },
  created() {
    this.id = this.$route.query.id;
    this.getList(1000); //待开播
    this.getList(1001); //直播中
  },
  methods: {
    showTime(item) {
      let days, hours, minutes, seconds;
      if (this.systemtime > item.starttime) {
        if (!this.timeFlag) {
          this.timeFlag = 1;
        }
        console.log(this.timeFlag)
        if (this.timeFlag == 10) {
          this.timeFlag=0;
          this.getList(1000);
          this.getList(1001);
        }
        return '<em class="tip">请耐心等待老师开播</em>';
      } else {
        var time = parseInt(item.starttime - this.systemtime);
        days = Math.floor(time / (1000 * 60 * 60 * 24));
        hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        minutes = Math.floor((time / (1000 * 60)) % 60);
        seconds = Math.floor((time / 1000) % 60);
        days = days >= 10 ? days : "0" + days;
        hours = hours >= 10 ? hours : "0" + hours;
        seconds = seconds >= 10 ? seconds : "0" + seconds;
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        return ` <span>${days}</span><em>天</em>
                      <span>${hours}</span><em>时</em>
                      <span>${minutes}</span><em>分</em>
                      <span>${seconds}</span><em>秒</em>`
      }

    },
    getList(livestatus) {
      var obj = {
        teacherid: this.id,
        pageNum: 1,
        pageSize: 10,
        livestatuList: [livestatus]
      }
      this.$post('/iart-api-scm/api/scm/activity/queryLiveListStudent', obj).then(res => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            this.systemtime = res.systemtime
            var data = res.data && res.data.rows ? res.data.rows : [];
            if (livestatus == 1000) {
              this.list2 = data;
              if (data.length) {
                this.countdown();
              }
            } else {
              this.list1 = data;

            }
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message })
        }
      })
    },
    subscribe(item, index, type) {
      let data = JSON.parse(JSON.stringify(item))
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
      } else {
        // if (item.subscribe==0) {
        var obj = {
          subscribetype: 1030,
          referencevalue: item.activityid,
        };
        this.$post(
          "iart-api-crm/api/crm/custservice/createCustomerSubscribe",
          obj
        ).then((res) => {
          if (res.code == 1) {
            //   this.getLive()
            data.appoint = data.appoint ? 0 : 1;
            this[type].splice(index, 1, data)
            // this.info.subscribeStatus != 1004 ? (this.info.subscribeStatus = 1004) : "";
            // this.info.reservecount++;
            // this.util.toast({ msg: "已订阅该直播" });
          } else {
            this.util.toast({ msg: res.message });
          }
        });
        // } else {
        //   this.util.toast({ msg: "已订阅该直播" });
        // }
      }
    },
    countdown() {
      let _this = this;
      if (!this.time) {
        _this.time = setInterval(() => {
          if (this.timeFlag) {
            ++this.timeFlag;
          }
          _this.systemtime += 1000
        }, 1000)
      }

    },
    detail(item) {
      this.util.Download();
      //   this.$router.push({
      //     path: '/h5/course/artHome/live',
      //     query: {
      //       id: item.activityid
      //     }
      //   })
    }
  },
}
</script>

<style lang="scss" scoped>
.liveList {
  padding: 16px;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: rgba(244, 244, 247, 1);
}
.common {
  h5 {
    font-size: 16px;
    line-height: 24px;
    color: rgba(53, 54, 60, 1);
    font-weight: 600;
  }
  ul {
    margin-top: 16px;
    li {
      margin-bottom: 16px;
      .info {
        > div {
          background: #ffffff;
          border-radius: 3px;
          padding: 0 32px;
        }
        .top {
          padding-top: 24px;
          padding-bottom: 24px;
          text-align: center;
          border-radius: 3px;
          border: 1px solid rgba(45, 45, 45, 0.1);
          .name {
            font-size: 18px;
            line-height: 25px;
            color: #343737;
            font-weight: 600;
          }
          .title {
            font-size: 12px;
            line-height: 17px;
            color: rgba(134, 135, 138, 1);
            margin-top: 6px;
            font-weight: 400;
          }
          .time {
            font-size: 12px;
            line-height: 17px;
            color: rgba(53, 54, 60, 1);
            margin-top: 6px;
            font-weight: 300;
          }
        }
        .line {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;
          background: transparent;
          margin-top: -12px;
          span {
            display: inline-block;
            width: 6px;
            height: 30px;
            background: rgba(204, 204, 210, 1);
            border-radius: 4px;
            position: relative;
          }
          span::before {
            position: absolute;
            top: -7px;
            left: -4px;
            display: inline-block;
            content: " ";
            width: 14px;
            height: 14px;
            background: rgba(244, 244, 247, 1);
            box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06);
            border-radius: 50%;
            z-index: 10;
          }
          span::after {
            position: absolute;
            bottom: -7px;
            left: -4px;
            display: inline-block;
            content: " ";
            width: 14px;
            height: 14px;
            background: rgba(244, 244, 247, 1);
            box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06);
            border-radius: 50%;
            z-index: 10;
          }
        }
        .content {
          border-radius: 3px;
          border: 1px solid rgba(45, 45, 45, 0.1);
          text-align: center;
          padding-top: 40px;
          padding-bottom: 40px;
          margin-top: -12px;
          .liveTime {
            color: rgba(45, 45, 45, 0.4);
            font-size: 12px;
            line-height: 15px;
            font-weight: 400;
          }
          .statusBox {
            font-size: 22px;
            line-height: 30px;
            div {
              margin-top: 16px;
            }
            .countdown {
              margin-top: 4px;
              /deep/ span {
                font-size: 36px;
                line-height: 46px;
                color: rgba(45, 45, 45, 1);
                font-weight: bold;
                text-align: center;
                display: inline-block;
                width: 44px;
              }
              /deep/ em {
                font-size: 11px;
                line-height: 16px;
                color: rgba(52, 55, 55, 0.4);
              }
              /deep/ .tip {
                font-size: 16px;
                line-height: 22px;
              }
            }

            .liveLabel {
              display: inline-block;
              margin-top: 24px;
              width: 56px;
              height: 26px;
              background: url(~@/assets/img/h5/live.png) no-repeat;
              background-size: 56px 26px;
            }
          }
          .opation {
            .tip {
              margin-top: 24px;
              // padding: 16px 0 0;
              // border-top: 0.5px dashed rgba(212, 212, 212, 1);
              // margin-top: 16px;
              span {
                display: block;
                // margin: 0 32px;
                background: rgba(201, 55, 61, 1);
                border-radius: 3px;
                font-size: 14px;
                line-height: 21px;
                color: rgba(255, 255, 255, 1);
                padding: 12px 0;
                text-align: center;
              }
            }
            .default {
              span {
                background: rgba(206, 206, 206, 1);
                color: #fff;
              }
            }
            .online {
              padding: 0 32px;
              color: rgba(45, 45, 45, 0.4);
              font-size: 12px;
              line-height: 17px;
              margin-top: 16px;
            }
          }
        }
      }
    }
  }
}
.common:not(:last-child) {
  margin-bottom: 32px;
}
</style>